<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="!invoices.length && errors" @tryAgain="getInvoices" />
    <div class="w-full h-full bg-gray-200 dark:bg-base-100 rounded-tr-3xl xl:px-9 pt-6 lg:pt-10 pb-14 " v-else>
        <div class="container">
            <div class="flex flex-col md:flex-row justify-between items-center md:items-center mb-6 lg:mb-8">
                <h3 class="flex items-center md:text-26 text-2xl dark:text-white text-biscay-700 font-semibold">
                    <i class="md:flex hidden w-2 h-2 dark:bg-white rounded-full bg-blue-700 ml-2"></i>
                    {{ __('Invoices') }}
                </h3>
                <div class="flex mt-6 md:mt-0 flex-col lg:flex-row w-full md:w-auto justify-end">
                    <div class="flex mt-4 lg:mt-0 justify-end">
                        <input
                            class="input w-full h-10 xl:pl-36 placeholder-gray-320 md:w-64 xl:w-80 ml-2 bg-gray-350 bg-opacity-10 rounded-lg  transition duration-200 text-sm text-gray-350 px-3 font-medium dark:!bg-base-300 dark:!text-white  focus:bg-blue-700 focus:bg-opacity-10 border border-blue-700  focus:border-opacity-100"
                            type="text" :placeholder="__('Search...')" v-model="searchValue">
                        <button @click="search"
                            class=" bg-blue-600 disabled:opacity-70 disabled:!bg-blue-600 flex items-center h-10 md:px-5 px-3 rounded-md text-white font-semibold text-sm transition duration-200 hover:bg-blue-800 ">
                            {{ __('Search') }}
                        </button>
                    </div>
                           <div class="flex order-first justify-between lg:order-last">
                      <Dropdown labelClass="btn-outline" customClass="lg:mr-2">
                        <template #label>
                            {{ state }}
                        </template>
                             <ul class="menu dropdown-content bg-base-100 rounded-box z-[2] w-36 p-2 shadow lg:!end-auto">
                            <li><a :class="{'btn-active': $route.query.status == 'final'}" @click="controleState($event, 'final')" data-filter-id="final">{{ __('Final invoice') }}</a></li>
                            <li><a :class="{'btn-active': $route.query.status == 'proforma'}" @click="controleState($event, 'proforma')" data-filter-id="proforma">{{ __('Proforma invoice') }}</a></li>
                        </ul>
                        </Dropdown>
                    <div class="flex justify-end order-first lg:order-last lg:mr-2" v-if="can('invoice.create')">
                        <router-link :to="{name: 'user.invoice.create'}"
                            class="btn btn-outline btn-info btn-base">
                            <span class="mt-0.5">{{ __('Add invoice') }}</span>
                        </router-link>
                    </div>
                    </div>
                </div>
            </div>
            <div class="rounded-2xl dark:bg-base-300 bg-white">
              <TableInvoice :invoices="invoices" @setItem="setItem" />
            </div>
            <Pagination :meta="meta" @setPage="setPage" class="!mt-6" />
        </div>
    </div>
   <ModalDelete id="invoice-delete-modal" :title="__('Delete invoice')" :content="__('Are you sure to delete this invoice?')"  @remove="removeInvoice" />
</template>
<script setup>
import { ref, onMounted, computed ,onUpdated} from 'vue';

const { getInvoices, loading, errors, meta, router,remove, route,loadingBtn, invoices,removeInvoice } = useDashboard();
const searchValue = ref(route.query.search || '');
const statusTypes = ['all','not_sent', 'unpaid', 'partially_paid', 'paid', 'canceled', 'rejected'];
const state = ref('');
const setQuery = (key, value) => {
    getInvoices(window.setQuery(router, route, key, value));
}
const controleState = (e, filter) => {
    state.value = e.target.textContent.trim()
    setQuery('status', filter);
}
const setPage = (p) => {
    setQuery('page', p.toString());
};
const setItem = (item) => Object.assign(remove, item);
const search = () => {
    setQuery('search', searchValue.value)
}
onMounted(() => {
    getInvoices(route.query);
});
onUpdated(() => state.value = document.querySelector(`[data-filter-id=${route.query.status || 'final'}]`)?.textContent?.trim())
</script>